import React, { Component } from 'react';

import { Form, TreeSelect } from 'antd';

import service from '../../services';
const FormItem = Form.Item;

class Name extends Component {
    constructor(props) {
        super(props);
        this.param = props.param || {};

        this.state = {
            value: undefined,
            data: [],
            maps: {}
        };
    }

    componentDidMount() {
        this.querySearch(this.param);
    }

    querySearch(param) {
        return service.evals.querySearchObjectTree(param)
        .then((response) => {
            this.setState({
                value: this.props.value ? [this.props.value + ''] : undefined
            });

            const data = this.transform(response.data);

            this.setState({
                data: data,
                maps: response.maps
            });
        });
    }

    transform(data) {
        return data.map(item => {
            if(item.children) {
                return {
                    title: item.label,
                    key: item.key,
                    value: item.value,
                    children: this.transform(item.children),
                    disabled: true
                }
            }
            return {
                title: item.label,
                key: item.key,
                value: item.value,
                selectable: true
            }
        })
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value ? [nextProps.value + ''] : undefined,
            });
        }

        if(nextProps.param && nextProps.param.pid && nextProps.param.pid != this.param.pid) {
            this.param = nextProps.param;
            this.querySearch(nextProps.param);
        }
    }

    handleChange(value) {
        this.setState({
            value: value
        });

        if(this.props.handleChange) {
            this.props.handleChange({
                targetId: value,
                targetName: this.state.maps[value]
            });
        }
    }

    render() {
        const {label,style , name, notAllowClear, getFieldDecorator} = this.props;
        const { data, value } = this.state;
        return (
            <FormItem label={label || "评价指标"}>
                {
                    getFieldDecorator ? (
                        getFieldDecorator(name, {
                            initialValue: value,
                            rules: [{
                                required: true,
                                message: '请选择评价指标',
                            }],
                        })(
                            <TreeSelect
                            allowClear={notAllowClear === true ? false : true}
                            value={value}
                            treeDefaultExpandAll={true}
                            treeData={data}
                            dropdownClassName="org-tree-select"
                            placeholder='请选择...'
                            treeDefaultExpandedKeys={['42']}
                            style= {style || {width: 240}}
                            onChange={(value) => {
                                if(value) {
                                    this.handleChange(value);
                                } else {
                                    this.handleChange(value);
                                }
                            }}
                            ></TreeSelect>
                        )
                    ) : (
                        <TreeSelect
                        treeDefaultExpandAll={true}
                        allowClear={notAllowClear === true ? false : true}
                        value={value}
                        treeData={data}
                        dropdownClassName="org-tree-select"
                        placeholder='请选择...'
                        treeDefaultExpandedKeys={['42']}
                        style= {style || {width: 240}}
                        onChange={(value) => {
                            if(value) {
                                this.handleChange(value);
                            } else {
                                this.handleChange(value);
                            }
                        }}
                        ></TreeSelect>
                    )
                }

            </FormItem>
        );
    }
}

export default Name;